// eslint-disable-next-line import/prefer-default-export
export const CMS = {
  SetUpTransfer: [
    'regularAccountTypeName',
    'regularAccountLimit',
    'catchUpAccountLimit',
    'brokerageAccountName',
    'brokerageAccountNumber',
    'brokerageAccountType',
    'riaPhoneNum',
  ],
  EditTransaction: [
    'regularAccountTypeName',
    'regularAccountLimit',
    'catchUpAccountLimit',
    'brokerageAccountName',
    'brokerageAccountNumber',
    'brokerageAccountType',
    'riaPhoneNum',
  ],
  Transfer: ['type', 'frequency', 'description', 'bankName', 'accountType', 'accountNumber', 'numLinked'],
  OverviewPage: ['type', 'frequency', 'description', 'bankName', 'accountType', 'accountNumber', 'numLinked'],
  AccountsPage: ['type', 'frequency', 'description', 'bankName', 'accountType', 'accountNumber', 'numLinked'],
  ConfirmTransaction: ['transferFrequency', 'type', 'amount', 'fromName', 'toName', 'pendingDays'],
  Confirm: ['userEmail', 'type', 'pendingDays'],
  ConfirmBankLinkPage: ['bankName', 'brokerageAccountName'],
  LiquidationSuccessPage: ['accountName', 'bankName', 'addressType'],
};
